(() => {
  const SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
  const SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';
  const FULLPAGE_QUERY = '(min-width: 0px)';
  const STATE_KEY = '__tootoHomeFullpage';

  const injectStyles = () => {
    if (document.getElementById('tooto-home-fullpage-styles')) return;

    const style = document.createElement('style');
    style.id = 'tooto-home-fullpage-styles';
    style.textContent = `
      @media screen {
        html.tooto-home-fullpage-active,
        html.tooto-home-fullpage-active body {
          height: 100%;
          overflow: hidden;
        }

        main[data-template="index"].tooto-home-fullpage-main {
          height: calc(100svh - var(--header-group-height, var(--header-height, 0px)));
          overflow: hidden;
        }

        .tooto-home-fullpage-swiper {
          height: 100%;
          overflow: hidden;
          width: 100%;
        }

        .tooto-home-fullpage-wrapper {
          height: 100%;
        }

        .tooto-home-fullpage-slide {
          background: var(--color-background, #fff);
          height: 100%;
          min-height: 100%;
          overflow: hidden;
          width: 100%;
        }

        .tooto-home-fullpage-slide > .section,
        .tooto-home-fullpage-slide > .shopify-section,
        .tooto-home-fullpage-slide > footer {
          min-height: 100%;
        }

        .tooto-home-fullpage-slide > .section {
          height: 100%;
        }

        .tooto-home-fullpage-slide.container-background-image,
        .tooto-home-fullpage-slide:has(> .slideshow-section) {
          display: block;
        }

        .tooto-home-fullpage-slide > .section-background {
          min-height: 100%;
        }

        .tooto-home-fullpage-slide > .slideshow-section,
        .tooto-home-fullpage-slide > .slideshow-section > slideshow-component,
        .tooto-home-fullpage-slide > .slideshow-section slideshow-container,
        .tooto-home-fullpage-slide > .slideshow-section slideshow-slides,
        .tooto-home-fullpage-slide > .slideshow-section slideshow-slide {
          height: 100%;
          min-height: 100%;
        }

        .tooto-home-fullpage-slide > .slideshow-section > slideshow-component {
          --slide-min-height: 100%;
          --slide-min-height-desktop: 100%;
        }

        .tooto-home-fullpage-slide > .slideshow-section slideshow-slides {
          align-items: stretch;
        }

        .tooto-home-fullpage-slide > .slideshow-section slideshow-slide {
          max-height: none;
        }

        .tooto-home-fullpage-footer-slide {
          overflow-x: hidden;
          overflow-y: auto;
          overscroll-behavior: contain;
        }

        .tooto-home-fullpage-footer-brand {
          height: var(--tooto-home-footer-brand-height, 100%);
          min-height: var(--tooto-home-footer-brand-height, 100%);
          width: 100%;
        }

        .tooto-home-fullpage-footer-brand,
        .tooto-home-fullpage-footer-brand > slideshow-component,
        .tooto-home-fullpage-footer-brand slideshow-container,
        .tooto-home-fullpage-footer-brand slideshow-slides,
        .tooto-home-fullpage-footer-brand slideshow-slide {
          height: var(--tooto-home-footer-brand-height, 100%);
          min-height: var(--tooto-home-footer-brand-height, 100%);
        }

        .tooto-home-fullpage-footer-brand > slideshow-component {
          --slide-min-height: var(--tooto-home-footer-brand-height, 100%);
          --slide-min-height-desktop: var(--tooto-home-footer-brand-height, 100%);
        }

        .tooto-home-fullpage-footer-brand slideshow-slides {
          align-items: stretch;
        }

        .tooto-home-fullpage-footer-brand slideshow-slide {
          max-height: none;
        }

        .tooto-home-fullpage-footer-slide > footer {
          display: grid;
          height: var(--tooto-home-footer-content-height, 100%);
          min-height: var(--tooto-home-footer-content-height, 100%);
          overflow: visible;
          width: 100%;
        }
      }
    `;
    document.head.append(style);
  };

  const loadSwiper = () => {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (window.tootoSwiper8Promise) return window.tootoSwiper8Promise;

    window.tootoSwiper8Promise = new Promise((resolve, reject) => {
      if (!document.querySelector(`link[href="${SWIPER_CSS}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = SWIPER_CSS;
        document.head.append(link);
      }

      const existing = document.querySelector(`script[src="${SWIPER_JS}"]`);
      if (existing) {
        existing.addEventListener('load', () => resolve(window.Swiper), { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = SWIPER_JS;
      script.async = true;
      script.addEventListener('load', () => resolve(window.Swiper), { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.append(script);
    });

    return window.tootoSwiper8Promise;
  };

  const playActiveMedia = (state, activeIndex) => {
    state.videos.forEach((video) => {
      const slide = state.slides[activeIndex];
      if (slide?.contains(video)) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  };

  const bindHoverUnderlineLinks = () => {
    if (window.__tootoHoverUnderlineLinksBound) return;
    window.__tootoHoverUnderlineLinksBound = true;

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const hero = target?.closest('.hero__container:has(.tooto-hover-underline)');
      if (!hero || target.closest('a, button, input, textarea, select, details, summary')) return;

      const link = hero.querySelector('.group-block__link[href], .hero__link[href]');
      if (!(link instanceof HTMLAnchorElement)) return;

      event.preventDefault();
      if (link.target === '_blank') {
        window.open(link.href, '_blank', 'noopener');
      } else {
        window.location.href = link.href;
      }
    });
  };

  const getFooterBrandSection = (sections) => {
    const lastSection = sections[sections.length - 1];
    if (!lastSection?.id) return null;
    return lastSection.id.includes('__slideshow_6C8W99') ? lastSection : null;
  };

  const bindFooterSlideScroll = (state) => {
    if (!state.footerSlide) return;

    state.footerWheelHandler = (event) => {
      const slide = state.footerSlide;
      const canScrollDown = slide.scrollTop + slide.clientHeight < slide.scrollHeight - 1;
      const canScrollUp = slide.scrollTop > 1;

      if ((event.deltaY > 0 && canScrollDown) || (event.deltaY < 0 && canScrollUp)) {
        event.stopPropagation();
      }
    };

    state.footerSlide.addEventListener('wheel', state.footerWheelHandler, { passive: true });
  };

  const updateFooterActiveState = (state, activeIndex) => {
    const isFooterActive = state?.footerSlide && state.slides[activeIndex] === state.footerSlide;
    document.documentElement.classList.toggle('tooto-home-footer-active', Boolean(isFooterActive));
  };

  const build = (main, footer) => {
    const sections = Array.from(main.children).filter((child) => child.classList?.contains('shopify-section'));
    if (!sections.length) return null;
    const footerBrandSection = getFooterBrandSection(sections);

    const state = {
      main,
      footer,
      sections,
      footerBrandSection,
      videos: [],
      slides: [],
      swiper: null,
      sectionPlaceholder: document.createComment('tooto-home-fullpage-sections'),
      footerPlaceholder: document.createComment('tooto-home-fullpage-footer'),
      swiperEl: document.createElement('div'),
      wrapper: document.createElement('div'),
      footerSlide: document.createElement('article')
    };

    state.swiperEl.className = 'tooto-home-fullpage-swiper swiper';
    state.wrapper.className = 'tooto-home-fullpage-wrapper swiper-wrapper';
    state.footerSlide.className = 'tooto-home-fullpage-slide tooto-home-fullpage-footer-slide swiper-slide';
    state.footerSlide.style.overflowX = 'hidden';
    state.footerSlide.style.overflowY = 'auto';

    main.insertBefore(state.sectionPlaceholder, sections[0]);
    sections.forEach((section) => {
      if (section === footerBrandSection) return;

      section.classList.add('tooto-home-fullpage-slide', 'swiper-slide');
      section.dataset.tootoHomeFullpageSlide = 'true';
      state.wrapper.append(section);
      state.slides.push(section);
    });

    if (footer) {
      footer.parentNode.insertBefore(state.footerPlaceholder, footer);
      if (footerBrandSection) {
        footerBrandSection.classList.add('tooto-home-fullpage-footer-brand');
        footerBrandSection.dataset.tootoHomeFullpageFooterBrand = 'true';
        state.footerSlide.append(footerBrandSection);
      }
      state.footerSlide.append(footer);
      state.wrapper.append(state.footerSlide);
      state.slides.push(state.footerSlide);
    }

    state.swiperEl.append(state.wrapper);
    main.insertBefore(state.swiperEl, state.sectionPlaceholder.nextSibling);
    main.classList.add('tooto-home-fullpage-main');
    document.documentElement.classList.add('tooto-home-fullpage-active');
    state.videos = Array.from(state.swiperEl.querySelectorAll('video'));
    bindFooterSlideScroll(state);

    return state;
  };

  const destroy = (state) => {
    if (!state) return;
    if (state.swiper) {
      state.swiper.destroy(true, true);
      state.swiper = null;
    }

    if (state.footerWheelHandler) {
      state.footerSlide.removeEventListener('wheel', state.footerWheelHandler);
      state.footerWheelHandler = null;
    }

    state.sections.forEach((section) => {
      section.classList.remove('tooto-home-fullpage-slide', 'swiper-slide');
      section.classList.remove('tooto-home-fullpage-footer-brand');
      delete section.dataset.tootoHomeFullpageSlide;
      delete section.dataset.tootoHomeFullpageFooterBrand;
      state.main.insertBefore(section, state.sectionPlaceholder);
    });

    if (state.footer && state.footerPlaceholder.parentNode) {
      state.footerPlaceholder.parentNode.insertBefore(state.footer, state.footerPlaceholder);
      state.footerPlaceholder.remove();
    }

    state.swiperEl.remove();
    state.sectionPlaceholder.remove();
    state.main.classList.remove('tooto-home-fullpage-main');
    document.documentElement.classList.remove('tooto-home-fullpage-active');
    document.documentElement.classList.remove('tooto-home-footer-active');
    delete window[STATE_KEY];
  };

  const init = () => {
    if (document.documentElement.classList.contains('shopify-design-mode')) return;

    const main = document.querySelector('main[data-template="index"]');
    if (!main) return;

    bindHoverUnderlineLinks();

    if (!window.matchMedia(FULLPAGE_QUERY).matches) {
      destroy(window[STATE_KEY]);
      return;
    }

    if (window[STATE_KEY]) {
      window[STATE_KEY].swiper?.update();
      return;
    }

    injectStyles();

    const state = build(main, document.querySelector('body > footer'));
    if (!state) return;
    window[STATE_KEY] = state;

    loadSwiper()
      .then((Swiper) => {
        if (window[STATE_KEY] !== state) return;

        state.swiper = new Swiper(state.swiperEl, {
          direction: 'vertical',
          effect: 'creative',
          slidesPerView: 1,
          speed: 720,
          watchSlidesProgress: true,
          creativeEffect: {
            limitProgress: 2,
            prev: {
              translate: [0, 0, -1]
            },
            next: {
              translate: [0, '100%', 0]
            }
          },
          resistanceRatio: 0,
          followFinger: false,
          allowTouchMove: true,
          threshold: 8,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 0.95,
            thresholdDelta: 5
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true
          },
          on: {
            init(swiper) {
              updateFooterActiveState(state, swiper.activeIndex);
              playActiveMedia(state, swiper.activeIndex);
            },
            slideChange(swiper) {
              updateFooterActiveState(state, swiper.activeIndex);
              playActiveMedia(state, swiper.activeIndex);
            }
          }
        });
      })
      .catch(() => destroy(state));
  };

  const onResize = () => window.requestAnimationFrame(init);

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', onResize);
  init();
})();
